import { Dashboard, Insights } from "@mui/icons-material";
import { FormattedMessage } from "react-intl";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Assets, Filee, NavBill, NavUser } from "utils/asset";

const Icon = ({ src, alt }) => <LazyLoadImage src={src} alt={alt} width="16" />;

// ==============================|| MENU ITEMS - PAGES ||============================== //

const pages = {
  id: "group-pages",
  title: <FormattedMessage id="pages" />,
  type: "group",
  children: [
    {
      id: "dashboard",
      title: <FormattedMessage id="dashboard" />,
      type: "item",
      url: "/dashboard",
      icon: () => <Dashboard sx={{ fontSize: 18 }} />,
      subject: "Dashboard",
    },

    {
      id: "mitras",
      title: <FormattedMessage id="mitra" />,
      type: "item",
      url: "/mitras",
      icon: () => <Icon src={NavUser} alt="invoice icon" />,
      subject: "Mitra",
    },

    // {
    //   id: "pkss",
    //   title: <FormattedMessage id="kerja sama" />,
    //   type: "item",
    //   url: "/pkss",
    //   icon: () => <Icon src={Filee} alt="invoice icon" />,
    //   subject: "PKS",
    // },

    // {
    //   id: "lease",
    //   title: <FormattedMessage id="offering" />,
    //   type: "item",
    //   url: "/lease-agreement",
    //   icon: () => <Icon src={Assets} alt="invoice icon" />,
    //   subject: "Offering",
    // },

    {
      id: "invoice",
      title: <FormattedMessage id="proforma invoice" />,
      type: "item",
      url: "/invoice",
      // icon: NavBill,
      icon: () => <Icon src={NavBill} alt="invoice icon" />,
      subject: "Invoice",
    },

    {
      id: "sales-recap",
      title: <FormattedMessage id="sales recap" />,
      type: "item",
      url: "/sales-recap",
      icon: () => <Icon src={NavBill} alt="invoice icon" />,
      subject: "SalesRecap",
    },
    // {
    //   id: "warning-letter",
    //   title: <FormattedMessage id="warning letter" />,
    //   type: "item",
    //   url: "/warning-letter",
    //   icon: () => <Icon src={NavBill} alt="invoice icon" />,
    //   subject: "WarningLetter",
    // },
    // {
    //   id: "penalty",
    //   title: <FormattedMessage id="penalty" />,
    //   type: "item",
    //   url: "/penalty",
    //   icon: () => <Icon src={NavBill} alt="invoice icon" />,
    //   subject: "Penalty",
    // },
    {
      id: "offering",
      title: "Penawaran",
      type: "item",
      url: "/offering",
      icon: () => <Icon src={Assets} alt="offering icon" />,
      subject: "Offering",
    },
    {
      id: "contracts-management",
      title: "Manajemen Kontrak",
      type: "item",
      url: "/contracts-management",
      icon: () => <Icon src={Filee} alt="contract icon" />,
      subject: "PKS",
    },
    {
      id: "contracts-monitoring",
      title: "Monitoring Kontrak",
      type: "item",
      url: "/contracts-management/monitoring",
      icon: () => <Insights sx={{ fontSize: 18 }} />,
      subject: "ContractNew",
    },
  ],
};

export default pages;
